<div class="button-group-field" [class.button-group-field--labeled]="!!label">
  @if (label) {
    <umss-label
      [text]="label"
      [size]="_labelSize"
      [required]="required"
      [disabled]="disabled"
    />
  }

  <div
    class="button-group"
    [class.button-group--wrap]="allowWrap"
    [class.button-group--measuring]="!_layoutReady"
    [attr.data-disabled]="disabled"
    [style.--cols]="allowWrap ? _resolvedGridCols : null"
    [style.--row-gap.px]="allowWrap ? rowGap : null"
  >
    <ng-content select="umss-toggle-button"></ng-content>
  </div>
</div>
